import { render } from "./authorBlock.vue?vue&type=template&id=7d3e8a4a&scoped=true&ts=true"
import script from "./authorBlock.vue?vue&type=script&lang=ts"
export * from "./authorBlock.vue?vue&type=script&lang=ts"

import "./authorBlock.vue?vue&type=style&index=0&id=7d3e8a4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3e8a4a"]])

export default __exports__